var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5184 0H14.4814C12.468 0 10.8428 1.63253 10.8428 3.64223V46.3614C10.8428 48.3693 12.468 50 14.4814 50H35.5184C37.5281 50 39.157 48.3693 39.157 46.3614V3.64223C39.157 1.63253 37.5281 0 35.5184 0ZM19.809 2.21194H30.1945C30.4569 2.21194 30.67 2.60367 30.67 3.08833C30.67 3.57299 30.4569 3.96655 30.1945 3.96655H19.809C19.5448 3.96655 19.3352 3.57299 19.3352 3.08833C19.3352 2.60367 19.5448 2.21194 19.809 2.21194ZM25.0017 46.4051C23.7208 46.4051 22.6786 45.3629 22.6786 44.0802C22.6786 42.7975 23.7208 41.759 25.0017 41.759C26.279 41.759 27.3212 42.7975 27.3212 44.0802C27.3212 45.3629 26.279 46.4051 25.0017 46.4051ZM36.4313 38.4447H13.5703V6.14569H36.4313V38.4447Z",
    fill: "#B87332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.2e49257f2047d378cf6c5a09e10b1345.svg";
export { ForwardRef as ReactComponent };